import Model from "@/models/Model";
import DateFormatter from "@/utils/DateFormatter";

export default class Claimform extends Model {

  get id() {
    return this.clnr;
  }

  get rowNumber() {
    return this.rownumber;
  }

  get signStatus() {
    return this.cstat;
  }

  get openedDate() {
    return this.open_dat ? DateFormatter.numericToDate(this.open_dat) : null;
  }

  get openedDateFormatted() {
    return this.openedDate ? this.openedDate.toLocaleDateString() : '-';
  }

  set openedDate(v) {
    this.open_dat = DateFormatter.isoToNumeric(v);
  }

  get signedDate() {
    return this.sign_dat ? DateFormatter.numericToDate(this.sign_dat) : null;
  }

  get signedDateFormatted() {
    return this.signedDate ? this.signedDate.toLocaleDateString() : '-';
  }

  set signedDate(v) {
    this.sign_dat = DateFormatter.isoToNumeric(v);
  }

  get details() {
    return this.bskl;
  }

  get signedBy() {
    return this.sign_namn;
  }

  get raderFel() {
    return this.rader_fel;
  }

  get raderMak() {
    return this.rader_mak;
  }

}